__webpack_require__.p = "https://2play.game/";